import { getPlatform } from "@tencentcloud/universal-api";
const isPC = getPlatform() === "pc";
const isH5 = getPlatform() === "h5";
const isWeChat = getPlatform() === "wechat";
const isApp = getPlatform() === "app";
const isUniFrameWork = typeof uni !== "undefined";
const isMobile = isH5 || isWeChat || isApp;
export {
  isApp,
  isH5,
  isMobile,
  isPC,
  isUniFrameWork,
  isWeChat
};
